import * as React from 'react';

import { BRAND_COLOR, MANTLE_MARK_PATH, MANTLE_MARK_VIEWBOX_SIZE } from './mantleLogo';

interface IMantleMarkPrimaryProps extends React.SVGProps<SVGSVGElement> {
  color?: string;
  size?: number;
}

const MantleMarkPrimary = ({
  color = BRAND_COLOR,
  size = 24,
  width = size,
  height = size,
  ...props
}: IMantleMarkPrimaryProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${MANTLE_MARK_VIEWBOX_SIZE} ${MANTLE_MARK_VIEWBOX_SIZE}`}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      {...props}
    >
      <path d={MANTLE_MARK_PATH} fill={color} />
    </svg>
  );
};

export default MantleMarkPrimary;
